import { PriceShort } from "src/components/styled/PriceShort"
import { useProductContext } from "../context"

export const ProductPrice = () => {
  const { resolvedPrice: price, resolvedRegularPrice: regularPrice } = useProductContext()

  return <PriceShort price={price} regularPrice={regularPrice} textAlign="left" size="lg" />
}
